import { BatteryChemistry, type TemperatureDeratingPoint } from '@brt/shared-types'

const LEAD_ACID_CURVE: TemperatureDeratingPoint[] = [
  { tempC: -20, factor: 0.60 },
  { tempC: -10, factor: 0.72 },
  { tempC: 0, factor: 0.80 },
  { tempC: 10, factor: 0.88 },
  { tempC: 20, factor: 0.95 },
  { tempC: 25, factor: 1.00 },
  { tempC: 30, factor: 1.00 },
  { tempC: 40, factor: 0.95 },
  { tempC: 50, factor: 0.88 },
  { tempC: 60, factor: 0.80 },
]

const LIFEPO4_CURVE: TemperatureDeratingPoint[] = [
  { tempC: -20, factor: 0.70 },
  { tempC: -10, factor: 0.82 },
  { tempC: 0, factor: 0.90 },
  { tempC: 10, factor: 0.96 },
  { tempC: 20, factor: 1.00 },
  { tempC: 25, factor: 1.00 },
  { tempC: 30, factor: 1.00 },
  { tempC: 40, factor: 0.98 },
  { tempC: 50, factor: 0.92 },
  { tempC: 60, factor: 0.85 },
]

const LIION_CURVE: TemperatureDeratingPoint[] = [
  { tempC: -20, factor: 0.65 },
  { tempC: -10, factor: 0.78 },
  { tempC: 0, factor: 0.88 },
  { tempC: 10, factor: 0.95 },
  { tempC: 20, factor: 1.00 },
  { tempC: 25, factor: 1.00 },
  { tempC: 30, factor: 1.00 },
  { tempC: 40, factor: 0.97 },
  { tempC: 50, factor: 0.90 },
  { tempC: 60, factor: 0.82 },
]

const NIMH_NICD_CURVE: TemperatureDeratingPoint[] = [
  { tempC: -20, factor: 0.75 },
  { tempC: -10, factor: 0.85 },
  { tempC: 0, factor: 0.92 },
  { tempC: 10, factor: 0.97 },
  { tempC: 20, factor: 1.00 },
  { tempC: 25, factor: 1.00 },
  { tempC: 40, factor: 0.96 },
  { tempC: 60, factor: 0.85 },
]

const ALKALINE_CURVE: TemperatureDeratingPoint[] = LIION_CURVE

export const TEMPERATURE_CURVES: ReadonlyMap<BatteryChemistry, TemperatureDeratingPoint[]> = new Map([
  [BatteryChemistry.LEAD_ACID_FLOODED, LEAD_ACID_CURVE],
  [BatteryChemistry.AGM, LEAD_ACID_CURVE],
  [BatteryChemistry.GEL, LEAD_ACID_CURVE],
  [BatteryChemistry.LI_FEPO4, LIFEPO4_CURVE],
  [BatteryChemistry.LI_ION, LIION_CURVE],
  [BatteryChemistry.NI_MH, NIMH_NICD_CURVE],
  [BatteryChemistry.NI_CD, NIMH_NICD_CURVE],
  [BatteryChemistry.ALKALINE, ALKALINE_CURVE],
])
